import React from "react";
import { FormControlLabel, FormGroup, Switch } from "@mui/material";
import { BannerFeedback } from "../../components/BannerFeedback";
import { FloatContainer } from "../../components/FloatContainer";
import "./negotiate.css";

/**
 * Fresh, versioned consent for a paid minor-audience purchase; legacy cycles
 * keep their historical automatic-promotion setting.
 * @story args { prepaid: true, value: false, disabled: false, pending: false, error: "" }
 * @story state Legacy { prepaid: false }
 * @story state ReadOnly { disabled: true }
 * @story state Pending { value: true, pending: true }
 * @story state Failed { error: "Não foi possível confirmar a configuração." }
 */
export function NegotiationConfig(props: {
  value: boolean;
  prepaid?: boolean;
  disabled: boolean;
  pending: boolean;
  error: string;
  onChange: (value: boolean) => void;
  onClose: () => void;
  onClearError: () => void;
}) {
  return (
    <FloatContainer className="negotiateConfig" close={props.onClose}>
      <BannerFeedback
        type="error"
        open={Boolean(props.error)}
        message={props.error}
        callback={props.onClearError}
      />
      <FormGroup>
        <FormControlLabel
          control={
            <Switch
              checked={props.value}
              disabled={props.disabled || props.pending}
              onChange={(_, checked) => props.onChange(checked)}
            />
          }
          label={
            props.prepaid ? "Patrocinar o público menor de idade" : "Habilitar promoção automática"
          }
        />
      </FormGroup>
      {props.prepaid && (
        <p className="negotiateConfigStatus">
          Com este modo, sua empresa mantém o público menor de idade de uma postagem vencida por uma
          empresa +18 quando tem o maior lance entre as demais empresas aptas e saldo reservado. Na
          apuração, paga o próprio lance, com o desconto mensal aplicável, sem taxa de monopólio nem
          tarifa de transferência. Ao habilitar, você aceita essa compra conforme os{" "}
          <a href="/termos" target="_blank" rel="noopener noreferrer">
            Termos de Uso
          </a>
          . A alteração fica registrada com a versão dos termos, o colaborador e a data. O modo não
          pode mudar entre o fim do leilão e o resultado.
        </p>
      )}
      {props.pending && (
        <p className="negotiateConfigStatus" role="status">
          Confirmando alteração...
        </p>
      )}
    </FloatContainer>
  );
}
